import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'

import { useArchiveStrategyMemoMutation } from '../hooks/useArchiveStrategyMemoMutation'
import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type InputValues } from '../utils'

export const StrategyMemoArchiveButton = () => {
  const { reset } = useFormContext<InputValues>()
  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const archiveStrategyMemoMutation = useArchiveStrategyMemoMutation({
    onSuccess: () => {
      reset()
      navigate(compile('strategyMemoList', { brandAccountId }))
    },
  })

  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    archiveStrategyMemoMutation.mutate()
  }, [archiveStrategyMemoMutation])

  return (
    <IconButton
      disabled={archiveStrategyMemoMutation.isPending}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    />
  )
}
